import { APIErrorResponse } from '@arc-publishing/sdk-subs-core/lib/utils/APIErrorResponse';
import JSONResponseHandler from '@arc-publishing/sdk-subs-core/lib/utils/JSONResponseHandler';
import { headers } from './constants';
import { getOptions, getValidURL } from './utils';
import AMP from './amp';

/**
 * Gets the AMPReaderID for the current user.
 *
 * @returns __Promise__ which resolves to an array representing the current user's AMPReaderID. If a AMPReaderID does not exist empty list will be returned.
 *
 * <details>
 *  <summary>
 *    On success (resolves)
 *  </summary>
 *
 * array
 *
 * </details>
 *
 * <details>
 *  <summary>
 *    On error (throws)
 *  </summary>
 * </details>
 */

export default async function getAMPReaderIDs(): Promise<APIErrorResponse | Array<string>> {
  const options: Object = await getOptions({ method: 'GET', headers });

  // TODO: move this parsing logic in AMP.options
  const url = typeof window !== 'undefined' ? getValidURL(AMP.apiOrigin) : AMP.apiOrigin;

  return fetch(`${url}/sales/public/v1/amp`, options)
    .then(res => {
      return JSONResponseHandler(res);
    })
    .then((json: APIErrorResponse | Array<string>) => {
      if (json && Array.isArray(json)) {
        return json;
      } else {
        throw json;
      }
    });
}
